import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Alert, CircularProgress, Stack, Typography } from "@mui/material";
import { IconRefresh } from "@tabler/icons";
import PageContainer from "src/components/container/PageContainer";
import ActionButton from "src/components/shared/ActionButton";
import { casesApi } from "src/pages/cases/api";

// The classic one-traveller page is retired (QA nadia-08, rania-15): one
// screen per application. Everything it had is on the case: the status of
// one traveller alone (Change status), the payment and its fee split, the
// visa upload (Record the decision), the answers and documents. An old link
// (/request/1612) opens the case on that traveller (1611-2).
export const caseAddress = (data, requestId) => {
  const traveller = data.travellers?.find((t) => t.request_id === Number(requestId));
  return `/cases/${data.id}${traveller && traveller.number > 1 ? `?traveller=${traveller.number}` : ""}`;
};

const Request = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);

  const open = useCallback(() => {
    setFailed(false);
    casesApi
      .get(Number(id), dispatch)
      .then((response) => {
        if (!response?.data) throw new Error("missing");
        navigate(caseAddress(response.data, id), { replace: true });
      })
      .catch(() => setFailed(true));
  }, [id, dispatch, navigate]);

  useEffect(() => {
    open();
  }, [open]);

  return (
    <PageContainer title="Opening the case" description="One traveller's request opens its case">
      {failed ? (
        <Alert
          severity="error"
          sx={{ mt: 1, alignItems: "center" }}
          action={
            <Stack direction="row" spacing={1}>
              <ActionButton startIcon={<IconRefresh size={16} />} onClick={open}>
                Try again
              </ActionButton>
              <ActionButton variant="text" onClick={() => navigate("/cases")}>
                Back to cases
              </ActionButton>
            </Stack>
          }
        >
          The case for request {id} did not open.
        </Alert>
      ) : (
        <Stack direction="row" spacing={1.5} alignItems="center" mt={2} role="status">
          <CircularProgress size={20} />
          <Typography>Opening the case…</Typography>
        </Stack>
      )}
    </PageContainer>
  );
};

export default Request;
